import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4ea2f53e&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=4ea2f53e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea2f53e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonSectionTitle: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/common/section-title.vue').default,CommonCustomImage: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/common/custom-image.vue').default,TopScheduleItem: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/top/schedule/item.vue').default})
